import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import useDemonstrationChartData from 'hooks/consume_api/query/useDemonstrationChartData'
import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import { project as projectList, demonstrationSubActivities } from './utils/dropDownData';
interface props {
    division: string,
    district: string,
    upazila: string,
    union: string,
    project: string
}
const Demonstration: React.FC<props> = ({ division, district, upazila, union, project }) => {
    const [selectedProject, setSelectedProject] = useState(project);
    const [selectedSubActivities, setSelectedSubActivities] = useState<any[]>(demonstrationSubActivities.slice(0, 3));
    
        useEffect(() => {
            setSelectedProject(project);
        }, [project]);

    const { data } = useDemonstrationChartData(division, district, upazila, union, selectedProject, selectedSubActivities.map((item: any) => item.id));
    console.log("Demonsdata=========",data)
    const handleExport = (indicator: number) => {
        let tableData: any = []
        if (indicator === 1) {
            tableData = [
                {
                    "Total Beneficiary": data?.data?.male?.series[0] || 0,
                    "Male Beneficiary": data?.data?.male?.series[1] || 0,
                    "Female Beneficiary": data?.data?.female?.series[1] || 0,
                    "Youth Beneficiary": data?.data?.female?.series[1] || 0, // Assuming Youth is same as Female Beneficiary for now
                }
            ];
        }
        else if (indicator === 2) {
             tableData = data?.data?.report?.map((row: any) => {
                const activityProps = demonstrationSubActivities.find(item => item.id == row.sub_activity_name_id);
                return {
                    "SubActivity": activityProps?.label || row.sub_activity_name_id,
                    "Male": row.male_count || 0,
                    "Female": row.female_count || 0,
                    "Youth Members": row.youth_members || 0,
                    "Women Headed Households": row.women_headed_households || 0,
                    "Ethnic Members": row.ethnic_members || 0,
                    "Total": (Number(row.male_count) + Number(row.female_count)) || 0,
                };
            }) || [];
        }


        const ws = XLSX.utils.json_to_sheet(tableData);
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, 'Beneficiary Data');
        XLSX.writeFile(wb, 'Demonstration_data.xlsx');
    };

    return (
        <>
            {/* <Typography sx={{ marginTop: "40px", marginBottom: "10px" }} variant='h3'>Demonstration</Typography> */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: 2 }}>
                    <Typography variant="h3">Demonstration</Typography>
                    <Autocomplete
                        options={projectList}
                        getOptionLabel={(option) => option.label}
                        value={projectList.find((item) => item.id === selectedProject) || null}
                        onChange={(event, value) => {
                            if (value) {
                                setSelectedProject(value.id);
                            } else {
                                setSelectedProject('-1');
                            }
                        }}
                        renderInput={(params) => <TextField {...params} label="Select project" variant="outlined" size="small" sx={{ width: 250 }} />}
                    />
                </Box>
           
            <Grid container >
                {data && (
                    <>

                        <Grid marginTop="10px" marginBottom="10px" item xs={12}>
                            <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
                                <Button onClick={() => handleExport(1)}>Download</Button>
                            </Box>
                            <TableContainer component={Paper} sx={{ border: '1px solid black', borderRadius: '1px' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Total Beneficiary</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Male Beneficiary</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Female Beneficiary</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black' }}>Youth Beneficiary</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        <TableRow>
                                            <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data?.male?.series[0]}</TableCell>
                                            <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data?.male?.series[1]}</TableCell>
                                            <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data?.female?.series[1]}</TableCell>
                                            <TableCell >{data?.data?.youth?.series[1]}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Grid>
                        <Grid item xs={12}>
                            <Chart
                                options={{
                                    chart: {
                                        type: "pie",
                                        toolbar: {
                                            show: true,
                                            tools: {
                                                download: true,
                                            },
                                        },
                                    },
                                    labels: ["Male", "Female", "Youth"], // Combined labels
                                    title: {
                                        text: "Demonstration by Category",
                                    },
                                } as ApexOptions}
                                series={[
                                    ((data?.data?.male?.series[1] / data?.data?.male?.series[0]) * 100), // Male count
                                    ((data?.data?.female?.series[1] / data?.data?.female?.series[0]) * 100), // Female count
                                    ((data?.data?.youth?.series[1] / data?.data?.youth?.series[0]) * 100), // Youth count
                                ]}
                                type="pie"
                                height={300}
                            />
                        </Grid>
                        {/* sub-activity multiple selection here */}
                        <Grid marginTop="10px" item xs={12}>
                             <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
                                <Autocomplete
                                    multiple
                                    limitTags={1}
                                    options={demonstrationSubActivities}
                                    getOptionLabel={(option) => option.label}
                                    value={selectedSubActivities}
                                    onChange={(event, value) => {
                                        setSelectedSubActivities(value);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Sub-Activities" variant="outlined" size="small" sx={{ width: 400 }} />
                                    )}
                                />
                                <Button onClick={() => handleExport(2)}>Download</Button>
                            </Box>
                            <TableContainer component={Paper} sx={{ border: '1px solid black', borderRadius: '1px' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>SubActivity</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Male</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Female</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Youth Members</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Women Headed Households</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Ethnic Members</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid black' }}>Total</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.data?.report?.map((row: any) => {
                                            const activityProps = demonstrationSubActivities.find(item => item.id == row.sub_activity_name_id);
                                            return (
                                                <TableRow key={row.sub_activity_name_id}>
                                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>
                                                        {activityProps?.label || row.sub_activity_name_id}
                                                    </TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.male_count}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.female_count}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.youth_members || 0}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.women_headed_households || 0}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.ethnic_members || 0}</TableCell>
                                                    <TableCell sx={{ borderBottom: '1px solid black' }}>{Number(row.male_count) + Number(row.female_count)}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Grid>
                    </>

                )}
            </Grid>
        </>
    )
}

export default Demonstration